import React from 'react';

export const RichText = ({ value, onTab }) => {
    const handleKeyDown = (e) => {
        if (e.key === 'Tab') {
            e.preventDefault();
            e.stopPropagation();
            onTab?.(e);
        }
    };

    // --- Robust Rendering Logic ---
    let content = null;

    if (value === null || value === undefined) {
        content = ''; // Render nothing for null/undefined
    } else if (Array.isArray(value)) {
        // Expected format: [{text:'...', font:{...}}]
        content = value.map((part, index) => {
            let text = part.text || ''; // Ensure text is a string
            // Basic HTML tag application (consider a safer sanitizer if HTML is complex)
            if (part.font) {
                if (part.font.bold) text = `<b>${text}</b>`;
                if (part.font.italic) text = `<i>${text}</i>`;
                if (part.font.underline) text = `<u>${text}</u>`;
                // Add more formatting as needed (color, size, etc.)
            }
            // Replace newlines with <br> for display
            text = text.replace(/\n/g, '<br>');
            return <span key={index} dangerouslySetInnerHTML={{ __html: text }} />;
        });
    } else if (typeof value === 'object' && value.text && value.hyperlink) {
        // Handle URL/Email link objects
        const isEmail = value.hyperlink.startsWith('mailto:');
        return ( // Return directly for links as they are anchor tags
            <a
                href={value.hyperlink}
                target={isEmail ? undefined : "_blank"}
                rel={isEmail ? undefined : "noopener noreferrer"}
                className={`hover:underline ${isEmail ? 'text-purple-600' : 'text-blue-600'}`}
                onClick={(e) => {
                    e.stopPropagation();
                    if (isEmail) {
                        e.preventDefault();
                        window.location.href = value.hyperlink;
                    }
                }}
                onKeyDown={handleKeyDown}
                tabIndex={0}
            >
                {value.text}
            </a>
        );
    } else if (typeof value === 'string') {
        // Treat plain string as simple text, convert newlines
        const text = value.replace(/\n/g, '<br>');
        // Use dangerouslySetInnerHTML in case the string contains HTML entities,
        // and to be consistent with the array handling.
        content = <span dangerouslySetInnerHTML={{ __html: text }} />;
    } else {
        // Fallback: Received something truly unexpected (e.g., a number, a different object type)
        console.error("RichText component received unexpected value format:", value);
        content = String(value); // Display as plain text
    }
    // --- End Robust Rendering Logic ---


    // Render within a div for consistent structure and event handling
    return (
        <div
            className="whitespace-pre-wrap" // Allows wrapping and preserves line breaks
            onKeyDown={handleKeyDown}
            tabIndex={0} // Make div focusable if needed
        >
            {content}
        </div>
    );
};